import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import RadioField from '../FormLegacy/FormFieldsV2/RadioField'

const SelectEventRefundOption = ({ refund, title, onChange }) => {
  const { t } = useTranslation(['calendar'])

  return (
    <div className="refund-popup">
      <div className="refund-popup__title">{title}</div>
      <div className="refund-popup__radio-wrap">
        <RadioField
          type="radio"
          value={true}
          name="withRefund"
          label={t('calendar:selectEventRefundOption.cancelWithRefund')}
          onChange={(e) => onChange(e.target.value)}
          checked={refund}
          additionalClass="refund-popup__radio"
        />
        <RadioField
          type="radio"
          value={false}
          name="withoutRefund"
          label={t('calendar:selectEventRefundOption.cancelWithoutRefund')}
          onChange={(e) => onChange(e.target.value)}
          checked={!refund}
          additionalClass="refund-popup__radio"
        />
      </div>
    </div>
  )
}

SelectEventRefundOption.propTypes = {
  onChange: PropTypes.func,
  title: PropTypes.string,
  refund: PropTypes.bool,
}

export default SelectEventRefundOption
